import { useContext, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { AxiosContext } from "services/axios.context";

const useAddTrackToRelease = (releaseId) => {
  const { client } = useContext(AxiosContext);
  const [error, setError] = useState("");
  const queryClient = useQueryClient();
  return {
    addTrackToRelease: useMutation(
      (trackId) =>
        client
          .post(`releases/${releaseId}/tracks/${trackId}/`)
          .then((res) => res.data),
      {
        onSuccess: () => {
          queryClient.invalidateQueries("releases");
          queryClient.invalidateQueries(`release-${releaseId}`);
        },
      }
    ),
    error: error,
  };
};

export default useAddTrackToRelease;
